import '../styles/ImageTextSection.css';

const im = require('../../../images/edakkal.jpeg');
const im2 = require('../../../images/caves.jpeg');

const ImageTextSection = () => {
    return (
        <div className="image-text-section">
            <div className="row">
                <div className="text">
                    <h2>Witness the Marvel of Nature’s Own Architecture</h2>
                    <p>Carved by nature and adorned with the scripts of our ancestors, the Edakkal Caves are a testament to the inexorable march of time. Marvel at the exquisite rock formations and feel the echoes of a time long past.</p>
                </div>
                <div className="image">
                    <img src={im2} alt="Edakkal Caves" />
                </div>
            </div>
            <div className="row">
                <div className="image">
                    <img src={im} alt="Edakkal Caves" />
                </div>
                <div className="text">
                    <h2>Breathe in the Air of a Land Forgotten</h2>
                    <p>Nestled away in the folds of time, shrouded by the Eden-like beauty of natural wilderness. It’s a journey back to the roots of our civilization, a walk through the hallowed pathways of history.</p>
                </div>
            </div>
        </div>
    );
}

export default ImageTextSection;